import type { ReactNode } from 'react';

interface Props {
  label: string;
  htmlFor: string;
  error?: string;
  hint?: string;
  children: ReactNode;
}

export function Field({ label, htmlFor, error, hint, children }: Props) {
  return (
    <div style={{ marginBottom: '0.9rem' }}>
      <label
        htmlFor={htmlFor}
        style={{ display: 'block', fontWeight: 600, marginBottom: '0.25rem', color: 'var(--navy)' }}
      >
        {label}
      </label>
      {children}
      {hint && !error && (
        <p className="muted" style={{ margin: '0.25rem 0 0' }}>
          {hint}
        </p>
      )}
      {error && (
        <p style={{ margin: '0.25rem 0 0', color: 'var(--danger)', fontSize: '0.9rem' }} role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

export const inputStyle: React.CSSProperties = {
  width: '100%',
  minHeight: 'var(--tap)',
  padding: '0.55rem 0.7rem',
  border: '1px solid var(--line)',
  borderRadius: 'var(--radius-sm)',
  fontSize: '16px',
  fontFamily: 'inherit',
  background: 'var(--surface)',
  color: 'var(--ink)',
};
